export const COPY = {
  close: 'Close',
  descriptionImageAlt: 'description for idea',
  ideaAvatarImageAlt: 'avatar logo',
};
